module.exports = __webpack_public_path__ + "static/media/gig.82bdd22a.png";